import { useTheme } from "@emotion/react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  DialogActions,
  Button,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState, useEffect } from "react";
import { TEAM_DATA, TeamKey } from "../../../models/TeamConstants";

interface TeamModalProps {
  open: boolean;
  onClose: () => void;
  selectedTeam: string | null;
  onTeamSelect: (newTeam: string | null) => void;
}

export default function UserTeamModal({
  open,
  onClose,
  selectedTeam: initialTeam,
  onTeamSelect,
}: TeamModalProps) {
  const theme = useTheme();

  const [selectedTeam, setSelectedTeam] = useState<string | null>(
    initialTeam && initialTeam.trim() !== "" ? initialTeam : null
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    setSelectedTeam(
      initialTeam && initialTeam.trim() !== "" ? initialTeam : null
    );
  }, [initialTeam]);

  const handleSubmit = async () => {
    const normalized =
      selectedTeam && selectedTeam.trim() !== "" ? selectedTeam : null;

    setIsSubmitting(true);
    try {
      onTeamSelect(normalized);
      onClose();
    } catch (err: any) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectedTeamData = selectedTeam
    ? TEAM_DATA[selectedTeam as TeamKey]
    : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 3, p: 2, width: "100%", maxWidth: 480 } }}
    >
      <DialogTitle>Select Your Team</DialogTitle>
      <DialogContent>
        <Typography>
          Choose wisely! Your team determines your leaderboard house.
        </Typography>

        <FormControl fullWidth sx={{ my: 2 }}>
          <InputLabel id="team-select-label">Choose a team</InputLabel>
          <Select
            labelId="team-select-label"
            label="Choose a team"
            value={selectedTeam ?? ""}
            onChange={(e) =>
              setSelectedTeam(e.target.value === "" ? null : e.target.value)
            }
          >
            {Object.keys(TEAM_DATA).map((team) => (
              <MenuItem key={team} value={team}>
                {team}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box textAlign="center" sx={{ p: 2 }}>
          <Typography variant="h2">
            {selectedTeamData?.image || "❓"}
          </Typography>
          <Typography>
            {selectedTeamData?.text || "No team selected yet"}
          </Typography>
        </Box>
      </DialogContent>

      <Divider sx={{ my: 1, opacity: 0.1 }} />

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} disabled={isSubmitting}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}